import React from 'react'
import IdleTimer from 'react-idle-timer'
import { useHistory } from 'react-router-dom'

const Timeout = () => {
  const history = useHistory()
  const timeoutLogout = 1000 * 60 * 14

  const onIdle = (e: any) => {
    history.push('/logout')
  }

  return <IdleTimer element={document} onIdle={onIdle} debounce={250} timeout={timeoutLogout} />
}

export default Timeout
